module.exports = "/src/views/player/captures/assets/defends.png";